import ReactGA from 'react-ga4';
import useStore from '../store/store';
import usePersistentAuthStore from '../store/persistentAuthStore';
import usePersistentStore from '../store/persistentStore';
import {logApiCallStart, logApiCallComplete} from './apiLogger';

const reporting = 'https://reports.setupad.com/setupad';
//const workbench = 'https://wb.setupad.coem/api';

const paymentsApi =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:5001/api'
    : 'https://api-payments.setupad.io/api';

// Workbench base URL:
// - development: proxy to local "/api"
// - master branch: production WB
// - other branches: staging WB
const workbench =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_WORKBENCH_URL ?? '/api'
    : process.env.REACT_APP_CURRENT_BRANCH === 'master'
      ? 'https://wb.setupad.com/api'
      : 'https://wb-api-dev.setupad.com/api';

const reportingDB =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:6001'
    : 'https://api-db-reporting.setupad.com';

export const endpoints = {
  addCustomEntries: `${workbench}/addCustomEntries`,
  getAdsTXT: `${workbench}/getAdsTXT`,
  setupadResellerAdsTxtLines: `${workbench}/client/setupadResellerAdsTxtLines`,
  checkAdsTxt: `${workbench}/checkAdsTxt/client`,
  googleAuth: `${workbench}/client/googleAuth`,
  getAnalyticsProperties: `${workbench}/client/getAnalyticsProperties`,
  getAssignedGoogleProperties: `${workbench}/client/getAssignedGoogleProperties`,
  getAnalyticsDataForDomain: `${workbench}/client/getAnalyticsDataForDomain`,
  getAnalyticsDataForOriginSources: `${workbench}/client/getAnalyticsDataForOriginSources`,
  getDecilesData: `${workbench}/client/getDecilesData`,
  getDecilesDataBySSP: `${workbench}/client/getDecilesDataBySSP`,
  assignGoogleProperty: `${workbench}/client/assignGoogleProperty`,
  disconnectGoogleProperty: `${workbench}/client/disconnectGoogleProperty`,
  authenticate: `${workbench}/client/authenticate`,
  refresh: `${workbench}/client/refresh`,
  refreshMenu: `${workbench}/client/refreshMenu`,
  feedback: `${workbench}/client/feedback`,
  totalclient: `${reporting}/web/api/totalclient`,
  totalclientown: `${reporting}/web/api/totalclientown`,
  totalclientpublisher: `${reporting}/web/api/totalclientpublisher`,
  totalclientsetupad: `${reporting}/web/api/totalclientsetupad`,
  clientperiod: `${reporting}/web/api/clientperiod`,
  clientperiodown: `${reporting}/web/api/clientperiodown2`,
  clientperiodsetupad: `${reporting}/web/api/clientperiodsetupad2`,
  clientperiodpublisher: `${reporting}/web/api/clientperiodpublisher2`,
  lastMonthRevenue: `${reporting}/api/payments/revenue`,
  minimumPayout: `${reporting}/api/payments/minimum`,
  invoices: `${reporting}/api/payments/invoices`,
  invoicePDF: `${workbench}/downloadClientInvoice`,
  scheduledRevenues: `${workbench}/client/scheduledRevenues`,
  billingDetails: `${reporting}/api/billing`,
  remindPassword: `${workbench}/client/remindPassword`,
  resetPassword: `${workbench}/client/resetPassword`,
  extensionReports: `${workbench}/client/extensionReports`,
  acceptTos: `${workbench}/client/acceptTos`,
  getRealtimeData: `${workbench}/realtime/client/getRealtimeFromGDF`,
  getGeoData: `${workbench}/googleReports/client/getGeoReport`,
  getPrebidReport: `${workbench}/googleReports/client/getPrebidReport`,
  getPanelChangesBySelection: `${workbench}/prebidPanel/client/getPanelChangesBySelection`,
  getDirectStackData: `${workbench}/googleReports/client/getDirectStackData`,
  getDemandStackData: `${workbench}/googleReports/client/getDemandStackData`,
  billingDetailsChangeNotification: `${workbench}/client/billingDetailsChangeNotification`,
  sendSecurityCode: `${workbench}/client/sendSecurityCode`,
  getAuth: `${workbench}/client/getAuth`,
  getOriginData: `${workbench}/client/getOriginData`,
  getNotificationMessage: `${workbench}/client/getNotificationMessage`,
  shareGraph: `${workbench}/sharing/share`,
  getSharedData: `${workbench}/sharing/getData`,
  addCMP: `${reportingDB}/api/cmp/add`,
  getCMP: `${reportingDB}/api/cmp/get`,
  checkCurrentCMP: `${reportingDB}/api/cmp/client/domain`,
  checkCMPbyUrl: `${reportingDB}/api/cmp/client/url`,
  fullVendorsList: `https://cmp.setupcmp.com/cmp/gvl/additional-gvl-information.json`,
  enabledByDefaultVendors: `https://cmp.setupcmp.com/cmp/gvl/default-vendors.json`,
  getDomainCategories: `${workbench}/domainCategoryClientUI`,

  // Adserver Domain history
  getDomainHistory: `${workbench.replace(
    '/api',
    ''
  )}/database-api/api/adserver/getDomainHistoryClientUI/domainId`,

  // Onboarding:
  setOnboardingCompleted: `${workbench}/client/setOnboardingCompleted`,
  setAdserverOnboardingCompleted: `${workbench}/client/setAdserverOnboardingCompleted`,
  dismissReviewUsPopup: `${workbench}/client/dismissReviewUsPopup`,

  // MCM:
  getPublishers: `${workbench}/mcm/publishers`,
  getMCMstatus: `${workbench}/mcm/getMCMstatus`,
  getSitesByNetworkCode: `${workbench}/mcm/getSitesByNetworkCode`,
  inviteChildPublisher: `${workbench}/mcm/child/invite`,

  // Self serve:
  assignSelfServeAuth: `${workbench}/client/selfServe/assignAuth`,
  getAssignedSelfServeAuth: `${workbench}/client/selfServe/getAssignedAuth`,
  getAllNetworks: `${workbench}/client/selfServe/getAllNetworks`,
  assignNetwork: `${workbench}/client/selfServe/assignNetwork`,
  createTestNetwork: `${workbench}/client/selfServe/createTestNetwork`,
  getSitesList: `${workbench}/client/selfServe/getSitesList`,
  createSiteAndDomain: `${workbench}/client/selfServe/createSiteAndDomain`,
  createPublisher: `${workbench}/client/selfServe/createPublisher`,
  importDomain: `${workbench}/client/selfServe/importDomain`,
  generateOrders: `${workbench}/client/selfServe/orderGenerator/generateOrders`,
  getOrderStatus: `${workbench}/client/selfServe/orderGenerator/orderStatus`,
  getHistoricalDataStatus: `${workbench}/client/selfServe/dataFetcher/status`,
  consumedCreditsStart: `${workbench}/client/selfServe/dataFetcher/consumedCreditsStart`,
  createPaymentIntent: `${paymentsApi}/client/create-payment-intent`,
  createSubscription: `${paymentsApi}/client/subscription/create`,
  sendReferralEmail: `${paymentsApi}/referral`,
  getSubscription: `${paymentsApi}/client/subscription`,
  getInvoices: `${paymentsApi}/client/invoices`,
  getCustomer: `${paymentsApi}/client/customer`,
  getPrices: `${paymentsApi}/client/prices`,
  addPaymentMethod: `${paymentsApi}/client/addPaymentMethod`,
  changeDefaultPm: `${paymentsApi}/client/changeDefaultPm`,
  deletePaymentMethod: `${paymentsApi}/client/deletePaymentMethod`,
  cancelSubscription: `${paymentsApi}/client/subscription/cancel`,
  createPaymentIntentOneTime: `${paymentsApi}/client/createPaymentIntentOneTime`,
  signEnterpise: `${paymentsApi}/client/signEnterpise`,
  taxCounter: `${paymentsApi}/client/taxCounter`,

  // Public Knowledge Base:
  publicArticlesList: `${workbench}/public/articles/publicList`,
  getPublicArticleById: `${workbench}/public/article`,

  // Blocklist (IAB categories per domain)
  getBlocklist: `${workbench}/client/blocklist`,
  updateBlocklist: `${workbench}/client/blocklist`,

  //Ticketing
  submitTicket: `${workbench}/client/ticketing/submitTicket`,
  getTicketsByAccountId: `${workbench}/client/ticketing/getTicketsByAccountId`,
  addComment: `${workbench}/client/ticketing/addComment`,
  getImageAttachment: `${workbench}/client/ticketing/getImageAttachment`,

  // Inventory
  getDataForDomain: `${reportingDB}/api/adserver/client/getDataForDomain`,

  // Analytics
  getAnalyticsData: `${workbench}/azureFetcher/client/getAzureData`,
  getAzureTotalsForFilter: `${workbench}/azureFetcher/client/getAzureTotalsForFilter`,
};

export const APICall = (query, retryCount = 0) => {
  //console.log('API call', query)
  return new Promise((resolve, reject) => {
    ReactGA.event({
      category: 'API',
      action: 'call',
      label: query.endpoint,
    });

    let request = {
      url: `${endpoints[query.endpoint]}${query.params ? `/${query.params}` : ''}`,
      options: query.options ? query.options : {},
    };

    const tracker = logApiCallStart({
      url: request.url,
      options: request.options,
      params: query.params,
    });

    fetch(request.url, request.options)
      .then(response => {
        const meta = {status: response.status, ok: response.ok};

        if (response.ok) {
          if (query.responseType === 'blob') {
            return response.blob().then(data => {
              logApiCallComplete(tracker, {...meta, response: data, responseType: 'blob'});
              return data;
            });
          }
          return response.json().then(data => {
            logApiCallComplete(tracker, {...meta, response: data});
            return data;
          });
        }

        if (query.endpoint === 'authenticate') {
          return response.json().then(data => {
            logApiCallComplete(tracker, {...meta, response: data});
            resolve(data);
          });
        }

        if (response.status === 401) {
          // Unauthenticated call (e.g. WB getAuth): return the error, keep the session
          if (!query.options?.headers?.Authorization) {
            return response
              .json()
              .catch(() => ({success: false}))
              .then(data => {
                logApiCallComplete(tracker, {...meta, response: data});
                return data;
              });
          }

          if (query._retried) return logout(tracker, meta);

          const auth = usePersistentAuthStore.getState().auth;
          const keepSignedIn = usePersistentStore.getState().keepSignedIn !== false;
          if (!auth?.wb_auth && !keepSignedIn) return logout(tracker, meta);

          // Refresh once, then retry with the tokens now in the store
          return refreshSession().then(ok => {
            if (!ok) return logout(tracker, meta);
            // Caller may have aborted while refresh was in flight (e.g. new fetch
            // started). Do not start a retry on an already-aborted signal.
            if (query.options?.signal?.aborted) {
              reject(createAbortError());
              return;
            }
            return APICall(
              {...query, options: withFreshTokens(query), _retried: true},
              retryCount
            ).then(resolve, reject);
          });
        }

        if (query.returnErrorResponse) {
          return response.json().then(data => {
            logApiCallComplete(tracker, {...meta, response: data});
            return data;
          });
        }

        logApiCallComplete(tracker, {...meta, response: {success: false}});
        return {success: false};
      })
      .then(json => {
        if (json !== undefined) {
          resolve(json);
        }
      })
      .catch(error => {
        // Intentional cancel (unmount, superseded request) — not an API failure
        if (isAbortError(error) || query.options?.signal?.aborted) {
          logApiCallComplete(tracker, {status: 0, ok: false, error: 'aborted'});
          reject(isAbortError(error) ? error : createAbortError());
          return;
        }

        logApiCallComplete(tracker, {status: 0, ok: false, error: error.message});
        if (query.retryOnTimeout && isTimeoutError(error)) {
          // Check if we've exceeded max retries (10 attempts total)
          const maxRetries = 10;
          if (retryCount >= maxRetries) {
            reject(new Error('Request failed after maximum retry attempts'));
            return;
          }

          // Call retry callback if provided
          if (query.onRetry) {
            query.onRetry();
          }

          // Calculate exponential backoff delay: 2s, 4s, 8s, 16s
          const baseDelayMs = 2000; // 2 seconds
          const delay = baseDelayMs * Math.pow(2, retryCount);

          // Add exponential backoff delay before retrying
          setTimeout(() => {
            if (query.options?.signal?.aborted) {
              reject(createAbortError());
              return;
            }
            APICall(query, retryCount + 1)
              .then(resolve)
              .catch(reject);
          }, delay);
        } else {
          ReactGA.event({
            category: 'API',
            action: 'error',
            label: `${query.endpoint}: ${error.message}`,
          });
          reject(error);
        }
      });
  });
};

const createAbortError = () => {
  if (typeof DOMException === 'function') {
    return new DOMException('The user aborted a request.', 'AbortError');
  }
  const error = new Error('The user aborted a request.');
  error.name = 'AbortError';
  return error;
};

const isAbortError = error =>
  error?.name === 'AbortError' ||
  error?.code === 20 ||
  /aborted/i.test(error?.message || '');

const logout = (tracker, meta) => {
  logApiCallComplete(tracker, {...meta, response: {message: 'Unauthorized — session cleared'}});
  usePersistentAuthStore.getState().clearAuth();
  const next = window.location.pathname + window.location.search;
  window.location.replace(`/login?next=${encodeURIComponent(next)}`);
};

// Rebuild request options with current tokens. Reporting API calls use reportingToken,
// everything else uses the Client UI JWT; JSON bodies carrying reportingToken are updated too.
const withFreshTokens = query => {
  const auth = usePersistentAuthStore.getState().auth;
  const bearer = endpoints[query.endpoint].startsWith(reporting) ? auth.reportingToken : auth.token;
  const options = {
    ...query.options,
    headers: {...query.options.headers, Authorization: `Bearer ${bearer}`},
  };
  if (typeof options.body === 'string') {
    options.body = options.body.replace(
      /"reportingToken":"[^"]*"/,
      `"reportingToken":"${auth.reportingToken}"`
    );
  }
  return options;
};

let refreshInFlight = null;

const refreshSession = () => {
  const auth = usePersistentAuthStore.getState().auth;
  if (!auth?.refreshToken) return Promise.resolve(false);

  if (!refreshInFlight) {
    refreshInFlight = fetch(endpoints.refresh, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({refreshToken: auth.refreshToken}),
    })
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (!data?.success || !data?.token || !data?.reportingToken) return false;
        const {success, ...session} = data;
        const prev = usePersistentAuthStore.getState().auth;
        // Prefer fresh session fields so removed/changed settings don't linger
        usePersistentAuthStore.getState().setAuth({
          ...session,
          ...(prev?.wb_auth ? {wb_auth: prev.wb_auth} : {}),
        });
        return true;
      })
      .catch(() => false)
      .finally(() => {
        refreshInFlight = null;
      });
  }

  return refreshInFlight;
};

// Check if the error is a timeout error
// Different browsers have different error messages, also depends on backend
// This works for our case when getPrebidReport times out
const isTimeoutError = error => {
  return (
    error.name === 'TypeError' &&
    (error.message === 'Failed to fetch' ||
      error.message.includes('timeout') ||
      error.message.includes('network error'))
  );
};
